import React, { useEffect, useMemo, useRef, useState } from 'react';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import { getName } from '@home/utils/common';
import { IMetricFilter, IMetricFilterOption } from '../useData';
import { getRegionSelectedData } from '@/pages/dashboard/components/NewFilter/util';
import { RegionSelectValueType } from '@home/components/NewRegionSelect/type';
import { FilterParams } from '..';
import classNames from 'classnames';
import { Bubble } from 'tea-component';
import { dynamicString } from '@home/utils/dynamicString';
import { isEqual } from 'lodash-es';

export interface IMetricsFilterProps {
  className?: string;
  value: RegionSelectValueType;
  // 其他筛选器值
  otherFilterValue?: FilterParams;
  options?: IMetricFilterOption[];
  language?: { [key: string]: string; };
  isEN: boolean;
  locale: string;
  // 框架类型
  frameType: string;
  onChange?: (
    value: RegionSelectValueType,
    metricList: IMetricFilterOption[],
  ) => void;
}

export interface IDisabledOpt {
  nameEn: string;
  nameCn: string;
  value: string;
}

// const MORE_METRIC_TEXT_EN = 'The maximum limit is 15 metrics';
// const MORE_METRIC_TEXT_CN = '最多不超过15个指标';
const NOT_SUPPORT_TEXT_EN =
  "This metric doesn't support genre/country/platform filters";
const NOT_SUPPORT_TEXT_CN = '该指标暂不支持分品类/国家/平台';
const PLEASE_CHOOSE_METRICS_EN = 'Please choose metrics';
const PLEASE_CHOOSE_METRICS_CN = '请选择指标';

const NOT_SUPPORT_DIM_TEXT1_CN = '暂不支持分品类/国家/平台筛选，已自动取消勾选';
const NOT_SUPPORT_DIM_TEXT1_EN =
  'does not support genre/country/platform filters and has been automatically deselected.';

const NOT_SUPPORT_DIM_TEXT2_CN =
  '等指标暂不支持分品类/国家/平台筛选，已自动取消勾选';
const NOT_SUPPORT_DIM_TEXT2_EN =
  'do not support genre/country/platform filters and have been automatically deselected.';

const NOT_SUPPORT_DIM_TEXT3_EN =
  'Metrics such as {{metrics[0]}} and {{metrics[1]}} do not support genre/country/platform filters and have been automatically deselected.';

const MetricsFilter = (props: IMetricsFilterProps) => {
  const {
    className,
    value,
    options,
    otherFilterValue,
    isEN,
    locale,
    frameType,
    onChange,
  } = props;

  // 选中的指标key
  const [checkedList, setCheckedList] = useState<string[]>([]);

  // 不支持维度的提示
  const [notSupportText, setNotSupportText] = useState<{
    textEn: string;
    textCn: string;
  }>();

  // 显示、隐藏不支持维度的气泡框
  const [showNotSupportText, setShowNotSupportText] = useState<boolean>(false);

  // 不支持维度的指标
  const [notSupportMetrics, setNotSupportMetrics] = useState<IDisabledOpt[]>(
    [],
  );

  // 禁选的指标
  const disabledOptList = useRef<IDisabledOpt[]>([]);

  const hideNotSupportTextRef = useRef<any>([]);

  const getIsDiabledFilter = (
    filterList: IMetricFilter[],
    filterName: string,
    filterValue?: string,
    allValue?: string,
  ) => {
    // 获取对应的筛选器
    const filterItem = filterList?.find((item) => item?.name === filterName);

    // 没有对应筛选器时，只能选all
    if (!filterItem && filterValue !== allValue) {
      return true;
    }

    // 暂留，后续可能会用到
    // 值是空数组情况下，只在all下才可以选择
    // if (
    //   filterItem?.value?.length === 0 &&
    //   filterValue !== allValue &&
    //   isEmpty
    // ) {
    //   return true;
    // }

    // 有限制情况下，只在对应的平台才可以选
    // if (
    //   filterItem?.value?.length > 0 &&
    //   !filterItem?.value.includes(filterValue || '')
    // ) {
    //   return true;
    // }

    return false;
  };

  // // 根据指标对应的筛选器，禁用对应的指标
  const getFilterOptionDisabled = (
    filter: IMetricFilter[],
    otherFilterValues?: FilterParams,
  ) => {
    const { platform = '', country = '', genre = '' } = otherFilterValues || {};

    if (
      getIsDiabledFilter(
        filter,
        'platform',
        platform,
        frameType === 'Mobile' ? 'Mobile' : 'PC&Console',
      )
    ) {
      return true;
    }

    if (getIsDiabledFilter(filter, 'country', country, 'global')) {
      return true;
    }

    if (getIsDiabledFilter(filter, 'genre', genre, '255')) {
      return true;
    }

    return false;
  };

  // 对数据格式进行处理,区分分类、指标、禁用
  const newOptions = useMemo(() => {
    // let checkList = [...checkedList];
    // if (checkList.length > 15) {
    //   checkList = checkList.slice(0, 15);
    // }
    const categorys: any = {};
    // 每次先清空记录
    disabledOptList.current = [];
    // 组装分类、指标
    options?.forEach((item: IMetricFilterOption) => {
      const {
        category,
        category_ch,
        category_en,
        metric,
        metric_en,
        metric_ch,
        filter,
      } = item;

      // 超过15个，且不在前15个内
      // const isMore15 = checkedList.length >= 15 && !checkList.includes(metric);

      // 指标得支持其他3个筛选器
      const filterDisabled = getFilterOptionDisabled(filter, otherFilterValue);

      // const disabled = isMore15 || filterDisabled;
      const disabled = filterDisabled;

      // 指标hover文案
      // let metricBubbleContentEn = metric_en;
      // let metricBubbleContentCn = metric_ch;
      let metricBubbleContentEn;
      let metricBubbleContentCn;

      if (disabled) {
        // 记录disabled选项
        disabledOptList.current?.push({
          nameCn: metric_ch,
          nameEn: metric_en,
          value: metric,
        });
        // metricBubbleContentEn = isMore15
        //   ? MORE_METRIC_TEXT_EN
        //   : NOT_SUPPORT_TEXT_EN;
        // metricBubbleContentCn = isMore15
        //   ? MORE_METRIC_TEXT_CN
        //   : NOT_SUPPORT_TEXT_CN;
        metricBubbleContentEn = NOT_SUPPORT_TEXT_EN;
        metricBubbleContentCn = NOT_SUPPORT_TEXT_CN;
      }

      const metricOpt = {
        text: metric_en,
        textCN: metric_ch,
        value: metric,
        disabled,
        bubbleContent: metricBubbleContentEn,
        bubbleContentCN: metricBubbleContentCn,
      };

      if (categorys[category]) {
        categorys[category].children.push(metricOpt);
      } else {
        categorys[category] = {
          text: category_en,
          textCN: category_ch,
          value: category,
          children: [metricOpt],
        };
      }
    });

    return Object.keys(categorys).map((key) => {
      // 关联分类disabled
      const item = categorys[key];
      const child = item?.children;
      if (child?.every((item: any) => item.disabled)) {
        return { ...item, disabled: true };
      }
      return item;
    });
  }, [options, checkedList, otherFilterValue]);

  useEffect(() => {
    if (notSupportMetrics?.length === 0) return;

    const disabledMetric = {
      metrics: notSupportMetrics.map((item) =>
        getName(isEN, item.nameEn, item.nameCn),
      ),
    };

    // 获取前2个指标名称
    const metricName1 = disabledMetric.metrics[0];
    const metricName2 = disabledMetric.metrics[1];
    let textEn;
    let textCn;

    // 区分1/2/超过2
    if (notSupportMetrics.length === 1) {
      textEn = `${metricName1} ${NOT_SUPPORT_DIM_TEXT1_EN}`;
      textCn = `${metricName1} ${NOT_SUPPORT_DIM_TEXT1_CN}`;
    } else if (notSupportMetrics.length === 2) {
      textEn = `${metricName1}、${metricName2} ${NOT_SUPPORT_DIM_TEXT2_EN}`;
      textCn = `${metricName1}、${metricName2} ${NOT_SUPPORT_DIM_TEXT1_CN}`;
    } else {
      textEn = dynamicString(NOT_SUPPORT_DIM_TEXT3_EN, disabledMetric);
      textCn = `${metricName1}、${metricName2} ${NOT_SUPPORT_DIM_TEXT2_CN}`;
    }

    // 展示3s的气泡提示
    setNotSupportText({ textEn, textCn });
    setShowNotSupportText(true);
    // 防止快速点击
    clearTimeout(hideNotSupportTextRef.current);
    hideNotSupportTextRef.current = setTimeout(() => {
      setShowNotSupportText(false);
    }, 3000);
  }, [notSupportMetrics]);

  const resultValue = useMemo(() => {
    // 过滤不支持维度的指标
    const markets: string[] = [];
    const notSupportMetrics: IDisabledOpt[] = [];
    if (disabledOptList.current?.length > 0) {
      value?.markets?.forEach((val) => {
        // 判断指标是否在禁选中
        const disabledOpt = disabledOptList.current.find(
          (metric) => metric.value === val,
        );
        if (disabledOpt) {
          notSupportMetrics.push(disabledOpt);
        } else {
          markets.push(val);
        }
      });
      setNotSupportMetrics(notSupportMetrics);
    } else {
      markets.push(...(value?.markets || []));
    }
    const newValue = {
      ...value,
      markets,
    };
    // 防止死循环
    if (!isEqual(value?.markets, newValue?.markets)) {
      const metricList =
        options?.filter((item) => newValue?.markets?.includes(item.metric)) ||
        [];
      onChange?.(newValue, metricList);
    }
    // 兜底过滤掉匹配不到的指标
    newValue.markets = newValue.markets?.filter((metric) =>
      options?.some((opt) => opt.metric === metric),
    );
    return getRegionSelectedData(newOptions, newValue);
  }, [value, newOptions]);

  const handleNewConfirm = (value: RegionSelectValueType) => {
    setCheckedList(value.markets);
    const newValue = { ...value };
    // 最多选15个
    // if (value.markets?.length > 15) {
    //   newValue.markets = newValue.markets?.slice(0, 15);
    //   newValue.type = 'markets';
    // }
    const metricList =
      options?.filter((item) => newValue?.markets?.includes(item.metric)) || [];
    onChange?.(newValue, metricList);
  };

  return (
    <div className="dbb-genre-benchmark-filter-col">
      <div className={classNames({ 'is-en': isEN })}>
        {getName(isEN, 'Metric', '指标')}
      </div>
      <div
        className={classNames({
          'dbb-genre-benchmark-filter-error':
            resultValue?.markets?.length === 0,
        })}
        style={{ display: 'flex', flex: '1' }}
      >
        <Bubble
          content={getName(
            isEN,
            notSupportText?.textEn,
            notSupportText?.textCn,
          )}
          arrowPointAtCenter
          visible={showNotSupportText}
        >
          <NewRegionSelect
            value={resultValue}
            className={className}
            language={{
              en: {
                button_region:
                  resultValue?.markets?.length === 0
                    ? PLEASE_CHOOSE_METRICS_EN
                    : 'category',
                button_market: 'Metrics',
                region_title: 'Genre',
              },
              cn: {
                button_region:
                  resultValue?.markets?.length === 0
                    ? PLEASE_CHOOSE_METRICS_CN
                    : '分类',
                button_market: '指标',
                region_title: '分类',
              },
            }}
            options={newOptions}
            onCloseReginSelect={handleNewConfirm}
            onChange={handleNewConfirm}
            closeOnScroll={true}
            locale={locale}
            shortcutOptions={undefined}
          />
        </Bubble>
        {resultValue?.markets?.length === 0 && (
          <div
            className={classNames('dbb-genre-benchmark-filter-error-text', {
              'is-en': isEN,
            })}
          >
            {getName(isEN, PLEASE_CHOOSE_METRICS_EN, PLEASE_CHOOSE_METRICS_CN)}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricsFilter;
